import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'

export const state = {
  workshops: []
}
export const mutations = {
  prepare(state, list) {
    if (list && Array.isArray(list)) {
      state.workshops = list
    } else {
      state.workshops = []
    }
  },
  clear(state) {
    state.workshops = []
  }
}
export const actions = {
  async refresh({ dispatch, commit, state }, options) {
    options = _.merge({ force: false }, options)

    // clear
    commit('clear')

    var result = await post(Endpoints.getUrl('workshop.list'))
    if (result.success) {
      commit('prepare', result.data.items)
    }
  },

  clear({ commit }) {
    commit('clear')
  }
}
export const getters = {
  all: state => {
    return state.workshops
  },
  getById: state => id => {
    return _.head(state.workshops.filter(x => x.id === id))
  },
  getActives: state => {
    return state.workshops.filter(x => x.isActive)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
